<template>
  <div class="d-flex align-center justify-end flex-grow-1">
    <v-btn
      variant="text"
      size="small"
      class="
          mr-2
          pa-0
          text-capitalize
          justify-start
          font-weight-regular
          d-flex
          align-center
          justify-center"
      color="basicRed"
      @click="closePicker"
    >
      Cancel
    </v-btn>
    <DpplAutoSizedButton
      height="32"
      width="63"
      class="ma-0 text-capitalize apply-button"
      small
      :disabled="disabled || incorrectInternalModalValue"
      @click="selectDate"
    >
      Apply
    </DpplAutoSizedButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  internalModelValue: {
    type: [Date, Array],
    default: null,
  },
  selectDate: {
    type: Function,
    required: true,
  },
  closePicker: {
    type: Function,
    required: true,
  },
  isWeek: {
    type: Boolean,
    default: false,
  },
});

const incorrectInternalModalValue = computed(() => {
  if (props.isWeek) {
    return !props.internalModelValue;
  }
  return props.internalModelValue?.length !== 2;
});
</script>

<style scoped lang="less">
:deep(.v-btn) {
  letter-spacing: normal;
}

:deep(.v-btn).apply-button {
  background-color: @bg-brand-default !important;
  color: @text-white !important;
  font-size: 14px;

  &:hover {
    background-color: @bg-brand-dark !important;
  }

  &[disabled], &.v-btn--disabled.v-btn--variant-flat {
    background-color: @bg-brand-light !important;
    color: @text-brand !important;
  }

  .v-btn__overlay {
    display: none;
  }
}
</style>
